import styled from "styled-components";
import { Card } from "@mui/material";

export const StyledCard = styled(Card)`
  &.MuiPaper-root {
    border-radius: 0.5rem;
    box-shadow: 0rem 0.75rem 1.5rem -0.5rem rgba(0, 0, 0, 0.1);
  }
`;
